import type { TaxonomyField } from '@/entities/taxonomy';
import { ownedRowCount } from './pruneEmptyRows';

/**
 * True when the edit adds, removes, reorders or re-parents a field, or removes rows.
 *
 * Rows removed means trailing rows pruned on commit, which strands any cell
 * finding on them. With several trailing blank rows (after repeated Add row)
 * the first commit prunes them, so that one commit is checked at once too.
 * Rows added is not structural: committing the last row appends a blank row
 * by itself, in the middle of typing a column.
 */
export function isStructuralChange(prev: TaxonomyField[], next: TaxonomyField[]): boolean {
  const sameOrder =
    prev.length === next.length &&
    prev.every(
      (f, i) => f.id === next[i].id && (f.parentId ?? null) === (next[i].parentId ?? null),
    );
  return !sameOrder || ownedRowCount(next) < ownedRowCount(prev);
}
